var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTimesheet = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9076 11.9176C15.4304 13.0459 14.6841 14.0402 13.734 14.8135C12.7838 15.5868 11.6586 16.1156 10.4569 16.3536C9.25514 16.5917 8.01338 16.5317 6.84017 16.1789C5.66696 15.8261 4.59803 15.1914 3.72682 14.33C2.85562 13.4687 2.20867 12.4071 1.84253 11.238C1.4764 10.0689 1.40223 8.82792 1.62651 7.62353C1.85078 6.41914 2.36668 5.28803 3.12909 4.32908C3.89151 3.37013 4.87722 2.61255 6.00006 2.12256",
    stroke: "#0077B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9C16.5 8.01509 16.306 7.03982 15.9291 6.12987C15.5522 5.21993 14.9997 4.39314 14.3033 3.6967C13.6069 3.00026 12.7801 2.44781 11.8701 2.0709C10.9602 1.69399 9.98491 1.5 9 1.5V9H16.5Z",
    stroke: "#0077B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimesheet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/timesheet.e85b25f8.svg";
export { ForwardRef as ReactComponent };